import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Cinematic full-bleed hero for /campaigns/$id under the Voxcanon
 * voice. Wide painting, massive Cinzel Decorative title overlaid, mono
 * uppercase eyebrow chrome ("CAMPAIGNS · D&D 5E · 14 SESSIONS"), and an
 * action slot for the Begin-session CTA. When `imageUrl` is absent we
 * render a parchment/cosmos gradient stand-in so the layout stays the
 * same shape even before art lands.
 */
export const VoxCampaignHero = ({ imageUrl, eyebrowSegments, title, subline, actions }: IProps): React.JSX.Element => {
  const segments = (eyebrowSegments ?? []).filter((s) => Boolean(s?.trim()))

  return (
    <div className={classes.root}>
      {imageUrl ? (
        <div
          className={classes.imageBg}
          style={{ backgroundImage: `url(${JSON.stringify(imageUrl).slice(1, -1)})` }}
          aria-hidden="true"
        />
      ) : (
        <div className={classes.fallback} aria-hidden="true" />
      )}
      <div className={classes.overlay} aria-hidden="true" />
      <div className={classes.content}>
        {segments.length > 0 && (
          <div className={classes.eyebrow}>
            {segments.map((seg, i) => (
              <span key={seg} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                {i > 0 && <span className={classes.eyebrowDot}>·</span>}
                {seg}
              </span>
            ))}
          </div>
        )}
        <h1 className={classes.title}>{title}</h1>
        {subline && <p className={classes.subline}>{subline}</p>}
        {actions && <div className={classes.actionRow}>{actions}</div>}
      </div>
    </div>
  )
}
